<template>
  <div>
    <table class="slds-table slds-table_cell-buffer slds-table_bordered" style="table-layout:fixed"> 
      <thead>
        <tr class="slds-line-height_reset">
          <template>
            <th class="" scope="col" v-for="(column, index) in columns" :key="index" style="font-size: 11px">
              <div class="slds-truncate" :title="column.label">{{column.label}}</div>
            </th>
          </template>
        </tr>
      </thead>
      <transition-group :name="currentAnimation" tag="tbody">
        {{mode}}
        <template v-if="mode === 'view'">
          <tr class="slds-hint-parent" v-for="(row, index) in rowsToShow" :key="`tr_${row[idColumn]}`">
           
            <template v-for="(column, colIndex) in Object.values(row)">
              <template v-if="columns[colIndex]">
                <td :data-label="columns[colIndex].label" :key="colIndex" scope="row" >
                  <div class="slds-truncate" :title="columns[colIndex].label" v-if="columns[colIndex].type === 'date'">{{column | formatDate($t('general.dateFormat'))}}</div>
                  <div class="slds-truncate" :title="columns[colIndex].label" v-else-if="columns[colIndex].type === 'url'">
                    <router-link :to="`${columns[colIndex].options.linkPrefix}/${row[columns[colIndex].options.targetField]}`" tag="a">
                      {{column}}
                    </router-link>
                  </div>
                  <div class="slds-truncate" :title="columns[colIndex].label" v-else>{{column}}</div>
                </td>
              </template>
            </template>
          </tr>
        </template>
        <template v-else>
          <tr class="slds-hint-parent" v-for="(row, index) in rowsToShow" :key="index">
            <td v-if="hasDeleteAction">
              <button
                class="slds-button slds-button_icon slds-button_icon-error"
                :title="$t('action.delete')"
                @click="$emit('deleteRow', { rowIndex: index })">
                <svg class="slds-button__icon" aria-hidden="true">
                  <use xlink:href="../../assets/symbols.svg#delete"></use>
                </svg>
              </button>
            </td>
            <template v-for="(column, colIndex) in columns">
              <td :data-label="column.label" :key="colIndex">
                <template v-if="column.type === 'text[]'">
                  <div class="slds-truncate" :title="column.label">
                    <IncludedFilter v-model="rowsToShow[index][column.name]" :ref="`input_${index}__${column.name}`" />
                  </div>
                </template>
                <template v-else-if="column.type === 'picklist'">
                  <Picklist
                    v-model="rowsToShow[index][column.name]"
                    :options="column.options.picklistValues"
                    :ref="`input_${index}__${column.name}`" />
                </template>
                <template v-else>
                  <div class="slds-truncate" :title="column.label">
                    <Input :type="column.type" v-model="rowsToShow[index][column.name]" :ref="`input_${index}__${column.name}`" />
                  </div>
                </template>
              </td>
            </template>
          </tr>
        </template>
      </transition-group>
    </table>
    
    <div v-if="showPaginationSection" class="pagination-section slds-m-top--medium">
      <div>
        <button class="slds-button slds-button_neutral" @click="goToFirstPage" :disabled="pageNumber === 0"> &lt;&lt; </button>
        <button class="slds-button slds-button_neutral slds-m-right--small" @click="goToPreviousPage" :disabled="pageNumber === 0"> &lt; </button>
        <span> {{ pageNumber + 1 }} / {{ pageNumbers + 1 }} </span>
        <button class="slds-button slds-button_neutral slds-m-left--small" @click="goToNextPage" :disabled="isNextButtonDisabled"> &gt; </button>
        <button class="slds-button slds-button_neutral" @click="goToLastPage" :disabled="isNextButtonDisabled"> &gt;&gt; </button>
      </div>
    </div>
  </div>
</template>
<script>
import Input from './Input'
import IncludedFilter from '../campaign-manager/filters/IncludedFilter'
import Picklist from './Picklist'

const PAGE_SIZE = 10

export default {
  components: {
    Input,
    IncludedFilter,
    Picklist
  },
  props: {
    columns: Array,
    canDeleteRow: Function,
    hasDeleteAction: Boolean,
    hasPreviewAction: Boolean,
    idColumn: String,
    mode: {
      type: String,
      default: 'view'
    },
    rows: Array,
    sortable: Boolean,
    sortingOptions: {
      type: Object,
      default () {
        return {
          field: "",
          directiion: ""
        }
      }
    }
  },
  computed: {
    rowsToShow () {
     return this.rows
    },
    endIndex () {
      return ((this.pageNumber + 1) * PAGE_SIZE - 1)
    },
    isNextButtonDisabled () {
      return this.rows.length <= (this.pageNumber + 1) * PAGE_SIZE
    },
    pageNumbers () {
      return Math.floor(this.rows.length / PAGE_SIZE)
    },
    showPaginationSection () {
      return this.mode === 'view' && this.rows.length > PAGE_SIZE
    },
    startIndex () {
      return this.pageNumber * PAGE_SIZE
    },
    hasActions () {
      return this.hasDeleteAction || this.hasPreviewAction
    },
    nbsp () {
      return '\xa0'
    }
  },
  data () {
    return {
      currentAnimation: 'slide-fade-left-delay',
      pageNumber: 0,
      sortedRows: [],
      innerSortingOptions : {
        field: '',
        direction: ''
      }
    }
  },
  methods: {
    goToFirstPage () {
      this.currentAnimation = 'slide-fade-left-delay'
      this.pageNumber = 0
    },
    goToLastPage () {
      this.currentAnimation = 'slide-fade-left-delay'
      this.pageNumber = this.pageNumbers
    },
    goToNextPage () {
      this.currentAnimation = 'slide-fade-left-delay'
      this.pageNumber++
    },
    goToPreviousPage () {
      this.currentAnimation = 'slide-fade-right-delay'
      this.pageNumber--
    },
    changeSort (header, forcedDirection) {
      this.goToFirstPage()
      const { field, direction } = this.innerSortingOptions
      const sortingOptions = {}
      if (field === header) {
        sortingOptions.field = header
        if (!forcedDirection) {
          if (direction === 'asc') {
            sortingOptions.direction = 'desc'
          } else {
            sortingOptions.direction = 'asc'
          }
        } else {
          sortingOptions.direction = forcedDirection
        }
      } else {
        sortingOptions.field = header
        sortingOptions.direction = forcedDirection || 'asc'
      }

      this.innerSortingOptions = sortingOptions

      const tempRows = _.cloneDeep(this.rows)
      this.sortedRows = tempRows.sort((a, b) => {
        if (!a[sortingOptions.field] || a[sortingOptions.field] < b[sortingOptions.field]) return sortingOptions.direction === 'asc' ? -1 : 1
        if (a[sortingOptions.field] === b[sortingOptions.field]) return 0
        if (!b[sortingOptions.field] || a[sortingOptions.field] > b[sortingOptions.field]) return sortingOptions.direction === 'asc' ? 1 : -1
      })
    },
    getSortClasses (header) {
      const { field, direction } = this.innerSortingOptions
      return {
        'slds-is-sorted slds-is-sorted_asc': field === header && direction === 'desc',
        'slds-is-sorted slds-is-sorted_desc': field === header && direction === 'asc'
      }
    }
  },
  watch: {
    rows () {
      this.goToFirstPage()
      this.sortedRows = this.rows
      if(this.sortable && this.sortingOptions.field && this.sortingOptions.direction){
        this.innerSortingOptions = this.sortingOptions
        this.changeSort(this.innerSortingOptions.field, this.innerSortingOptions.direction)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .pagination-section {
    bottom: 10px;
    display: flex;
    width: 100%;
    align-items: center;

    & > div {
      margin: auto;
    }
  }

  .wrap {
    width: 5rem;
    word-break: break-word;
    white-space: pre-line;
  }
</style>
